export var getAttributeValue = function (product, attributeName) {
    var _a;
    if (!product) {
        return '';
    }
    var attribute = (_a = product.attributes) === null || _a === void 0 ? void 0 : _a.filter(function (a) {
        return a.key.toLowerCase().indexOf(attributeName) === 0;
    })[0];
    return (attribute === null || attribute === void 0 ? void 0 : attribute.valueKey) || '';
};
